import * as MISC from '@/api/misc.js'

const getDefaultState = () => (
  {
    emailMessage: {
      email: '',
      message: ''
    },
    todoList: [],
    notifications: [],
    messageLoadedTime: 0,
    todoNext: 'INIT',
    notiNext: 'INIT'
  }
)

const state = getDefaultState()

export default {
  namespaced: true,
  state,
  mutations: {
    setEmailMessage (state, data) {
      state.emailMessage.email = data.email
      state.emailMessage.message = data.message
    },
    setTodoList (state, list) {
      state.todoList = list
    },
    setNotifications (state, list) {
      state.notifications = list
    },
    concatTodoList (state, list) {
      state.todoList = state.todoList.concat(list)
    },
    concatNotifications (state, list) {
      state.notifications = state.notifications.concat(list)
    },
    removeTodoItem (state, event) {
      let index = state.todoList.findIndex((v) => {
        return v.object.userId === event.userId && v.type === event.type
      })

      if (index > -1) {
        state.todoList.splice(index, 1)
      }
    },
    setPatientListNextToken (state, data) {
      state.todoNext = data.todoNext
      state.notiNext = data.notiNext
    },
    resetHomeMessages (state) {
      state.todoNext = 'INIT'
      state.notiNext = 'INIT'
      state.todoList = []
      state.notifications = []
      state.messageLoadedTime = 0
    },
    setMessageLoadedTime (state, time) {
      state.messageLoadedTime = time
    },
    // 重置 state
    RESET_STATE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async setHomeMessages (context) {
      let todoNext = context.state.todoNext || ''
      let notiNext = context.state.notiNext || ''

      try {
        let response = await MISC.getMessages(todoNext, notiNext)

        context.commit('setMessageLoadedTime', new Date().getTime())
        if (context.state.todoNext === 'INIT') {
          context.commit('setTodoList', response.data.todoList)
        } else if (
          context.state.todoNext != null &&
          context.state.todoNext.length > 0
        ) {
          context.commit('concatTodoList', response.data.todoList)
        }

        if (context.state.notiNext === 'INIT') {
          context.commit('setNotifications', response.data.notifications)
        } else if (
          context.state.notifications != null &&
          context.state.notifications.length > 0
        ) {
          context.commit('concatNotifications', response.data.notifications)
        }

        context.commit('setPatientListNextToken', {
          todoNext: response.data.todoNext,
          notiNext: response.data.notiNext
        })
      } catch (error) {
        throw error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/main.js